const ALL_PROFILES_QUERY_KEY = "contacts-search-profiles:all-profiles";

type ContactsSearchProfilesQueryKeys = {
    allProfiles: () => readonly string[];
};

export const contactsSearchProfilesQueryKeys: ContactsSearchProfilesQueryKeys = {
    allProfiles: (): readonly string[] => [ALL_PROFILES_QUERY_KEY],
};
